module.exports = __webpack_public_path__ + "static/media/impact-rock.24908d6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/impact-rock.png
// module id = 3601
// module chunks = 0